import Counterparty from "./Counterparty";
import Address from "./Address";
import CounterpartyVatHistory from "./CounterpartyVatHistory";

export default class CounterpartyLegalPerson extends Counterparty {
  constructor(
    idInDB,
    externalId,
    itn,
    comment,
    counterpartyVatHistoryList,
    isIntragroupTurnover,
    fullName,
    latinName,
    shortName,
    rrc,
    directoryLegalFormCode,
    ogrn,
    addresses
  ) {
    super(
      idInDB,
      externalId,
      "Legal person",
      itn,
      comment,
      counterpartyVatHistoryList,
      isIntragroupTurnover
    );

    this.fullName = fullName;
    this.latinName = latinName;
    this.shortName = shortName;
    this.rrc = rrc;
    this.directoryLegalFormCode = directoryLegalFormCode;
    this.ogrn = ogrn;
    this.addresses = addresses || [];

    this.displayName = this.getDisplayNameForList();
  }

  static createFromData(data) {
    const addresses =
      data.addresses && data.addresses.length > 0
        ? Address.createFromData(data.addresses)
        : [];


    const counterpartyVatHistoryList =
      Array.isArray(data.counterpartyVatHistoryList)
        ? data.counterpartyVatHistoryList.map(v =>
          CounterpartyVatHistory.createFromData(v)
        )
        : [];

    return new CounterpartyLegalPerson(
      data.counterparty.idInDB,
      data.counterparty.externalId,
      data.counterparty.itn,
      data.counterparty.comment,
      counterpartyVatHistoryList,
      data.counterparty.isIntragroupTurnover,
      data.counterparty.fullName,
      data.counterparty.latinName,
      data.counterparty.shortName,
      data.counterparty.rrc,
      data.counterparty.directoryLegalFormCode,
      data.counterparty.ogrn,
      addresses
    );
  }

  static createNew() {
    return new CounterpartyLegalPerson(
      null, // idInDB
      null, // externalId
      null, // itn
      null, // comment
      [],   // counterpartyVatHistoryList
      false, // isIntragroupTurnover
      null, // fullName
      null, // latinName
      null, // shortName
      null, // rrc
      null, // directoryLegalFormCode
      null, // ogrn
      []    // addresses
    );
  }

  static convertToSendData(item) {
    let addresses = [];
    for (let i = 0; i <item.addresses.length; i++) {
      let address = item.addresses[i];
      addresses.push(new Address(address.addressType, address.address, address.idInDB));
    }
    return {
      counterparty: {
        externalId: item.externalId,
        counterpartyType: item.counterpartyType,
        fullName: item.fullName,
        latinName: item.latinName,
        shortName: item.shortName,
        itn: item.itn,
        rrc: item.rrc,
        directoryLegalFormCode: item.directoryLegalFormCode,
        ogrn: item.ogrn,
        comment: item.comment,
        isIntragroupTurnover: item.isIntragroupTurnover
      },
      addresses,
      counterpartyVatHistoryList: item.counterpartyVatHistoryList.map(v =>
        CounterpartyVatHistory.convertToSendData(v)
      ),
      addresses: item.addresses.map(a =>
        new Address(a.addressType, a.address, a.idInDB)
      ),
    };
  }


  getDisplayName() {
    return this.fullName;
  }

  getDisplayNameForList() {
    return this.shortName;
  }
}
